import React from "react";
import { FaFacebook, FaInstagram} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* قسم السوشال ميديا */}
        <div className="footer-section">
          <h3>تابعونا</h3>
          <p>
            <a href="https://www.instagram.com/pro_techcenter?igsh=a2FjaGY2YmxqeWJx" target="_blank" rel="noreferrer">
              <FaInstagram /> Instagram
            </a>
          </p>
          <p>
            <a href="https://www.facebook.com/share/1JctSc8gXY/" target="_blank" rel="noreferrer">
              <FaFacebook /> Facebook
            </a>
          </p>
        </div>

        {/* قسم ساعات العمل */}
        <div className="footer-section">
          <h3>ساعات العمل</h3>
          <p>الإثنين: 9:00 - 20:30</p>
          <p>الثلاثاء: 9:00 - 20:30</p>
          <p>الأربعاء: 9:00 - 20:30</p>
          <p>الخميس: 9:00 - 20:30</p>
          <p>الجمعة: 9:00 - 20:30</p>
          <p>السبت: 9:00 - 14:00</p>
        </div>

        {/* قسم التواصل */}
        <div className="footer-section">
          <h3>تواصل معنا</h3>
          <p>Email: Protechcenter2024@gmail.com</p>
          <p>Phone: +961 70163001</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Pro-Tech Center. جميع الحقوق محفوظة.</p>
      </div>
    </footer>
  );
};

export default Footer;